/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { tool_pairing_draw } from './tool_pairing_draw';
import type { tool_pairing_team_army } from './tool_pairing_team_army';
export type tool_pairing_team = {
  id: string;
  lead_id: number | null;
  name: string;
  state: tool_pairing_team.state;
  draw: null | tool_pairing_draw;
  team_armies: Array<tool_pairing_team_army>;
};
export namespace tool_pairing_team {
  export enum state {
    PENDING = 'pending',
    CREATED = 'created',
  }
}
